import * as Styled from './LoadingSkeleton.styled';
import { P2PAvatar } from '../../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FeedItemLoader = () => /*#__PURE__*/_jsxs(Styled.LoaderSection, {
  children: [/*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Styled.AvatarLoader, {})
  }), /*#__PURE__*/_jsxs(Styled.ContentLoaderContainer, {
    children: [/*#__PURE__*/_jsx(Styled.BarLoader, {
      maxWidth: "100%"
    }), /*#__PURE__*/_jsx(Styled.BarLoader, {
      maxWidth: "145px"
    })]
  })]
});
export const LoadingSkeleton = () => /*#__PURE__*/_jsxs(Styled.LoadingSkeleton, {
  children: [/*#__PURE__*/_jsxs(Styled.LoaderSection, {
    hideOnMobileBreakpoint: true,
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(P2PAvatar, {})
    }), /*#__PURE__*/_jsx(Styled.InputLoader, {})]
  }), /*#__PURE__*/_jsx(FeedItemLoader, {}), /*#__PURE__*/_jsx(FeedItemLoader, {}), /*#__PURE__*/_jsx(FeedItemLoader, {})]
});